var _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPaperEjection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f9e6c9"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17.5,7.7 4.5,1.6 4.5,3.1 17.5,9.2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.5,11.5 4.5,5.4 4.5,6.9 17.5,13  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.5,15.3 4.5,9.2 4.5,10.7 17.5,16.8  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "3.1,12.3 19.6,20 19.6,8.7 21,9.3 21,22.2 3.1,13.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPaperEjection);
export default __webpack_public_path__ + "static/media/img_PaperEjection.531b65acfbe1cbca8350cdd93a4ccf6e.svg";
export { ForwardRef as ReactComponent };